import { useDispatch, useSelector } from 'react-redux';

import MicrosoftWordIntegrationCard from '~/components/Admin/IntegrationPage/ThirdPartyIntegrations/MicrosoftWordIntegrationCard';
import { Modal } from '~/eds/src/components/Modal/Modal';
import {
  useAdminConsent,
  useSharepointConfiguration,
} from '~/features/integrations/hooks';
import { slices } from '~/redux/slices';

export const MicrosoftWordIntegrationModal = () => {
  const dispatch = useDispatch();
  const action = useSelector(slices.newIntegrations.selectors.selectAction);
  const { integrationConfigurationStatus, saveConfiguration, isLoading } =
    useSharepointConfiguration();

  const { isConsentLoading, handleGrantAdminConsent } = useAdminConsent();

  if (action !== 'document-editing') {
    return null;
  }

  return (
    <Modal
      disableFooter
      title="Microsoft Word"
      isVisible={true}
      onHide={() => dispatch(slices.newIntegrations.actions.setAction(null))}
    >
      <MicrosoftWordIntegrationCard
        integrationConfigurationStatus={integrationConfigurationStatus}
        saveConfiguration={saveConfiguration}
        handleGrantAdminConsent={() => handleGrantAdminConsent()}
        isLoading={isLoading || isConsentLoading}
      />
    </Modal>
  );
};
